export const MAX_IMPORT_ROWS = 2000;

const parseCsvDetailed = (input) => {
  const textValue = String(input || "").replace(/^﻿/, "");
  const rows = [];
  let row = [];
  let field = "";
  let inQuotes = false;
  for (let i = 0; i < textValue.length; i += 1) {
    const ch = textValue[i];
    if (inQuotes) {
      if (ch === '"' && textValue[i + 1] === '"') {
        field += '"';
        i += 1;
      } else if (ch === '"') {
        inQuotes = false;
      } else {
        field += ch;
      }
    } else if (ch === '"' && field === "") {
      // A quote only opens a quoted field at the start of one; mid-field it is
      // a literal (e.g. 6' 2" tall) and must not swallow the rows after it.
      inQuotes = true;
    } else if (ch === ",") {
      row.push(field);
      field = "";
    } else if (ch === "\n" || ch === "\r") {
      if (ch === "\r" && textValue[i + 1] === "\n") i += 1;
      row.push(field);
      rows.push(row);
      row = [];
      field = "";
    } else {
      field += ch;
    }
  }
  if (field !== "" || row.length) {
    row.push(field);
    rows.push(row);
  }
  return {
    rows: rows.filter((r) => r.some((cell) => String(cell).trim() !== "")),
    unterminatedQuote: inQuotes,
  };
};

export const parseCsv = (input) => parseCsvDetailed(input).rows;

export const csvToObjects = (input, maxRows = MAX_IMPORT_ROWS) => {
  const { rows: parsedRows, unterminatedQuote } = parseCsvDetailed(input);
  const [header, ...body] = parsedRows;
  if (!header) {
    return { headers: [], rows: [], truncated: false, unterminatedQuote };
  }
  const headers = header.map((h) => String(h).trim());
  const rows = body.slice(0, maxRows).map((cells) =>
    headers.reduce((acc, h, idx) => {
      if (h) acc[h] = cells[idx] !== undefined ? String(cells[idx]).trim() : "";
      return acc;
    }, {}),
  );
  return {
    headers,
    rows,
    truncated: body.length > maxRows,
    unterminatedQuote,
  };
};

export const chunk = (list, size) => {
  const out = [];
  for (let i = 0; i < list.length; i += size) out.push(list.slice(i, i + size));
  return out;
};

export const IMPORT_TEMPLATE_HEADERS = [
  "type",
  "first_name",
  "last_name",
  "email",
  "phone",
  "min_price",
  "max_price",
  "beds",
  "baths",
  "city",
  "zips",
  "property_type",
  "timeline",
  "address",
  "state",
  "zip",
  "price",
];

export const importTemplateCsv = () =>
  [
    IMPORT_TEMPLATE_HEADERS.join(","),
    'buyer,Ana,Lee,ana@example.com,317-555-0101,300000,450000,3,2,"Carmel, IN","46032 46033",Single Family,3-6 months,,,,',
    "seller,Bo,Ruiz,bo@example.com,317-555-0199,,,,,Carmel,,,,9 Oak Ct,IN,46032,510000",
  ].join("\n");
